module.exports = __webpack_public_path__ + "img/icon_ondivan_red.90ebfed7.svg";